import {
  AUTOFILL_SETTING_LOOP,
  AUTOFILL_SETTING_REPEAT
} from '@/constants';

// Helper function to check if the string has leading zeros
const hasLeadingZero = num => /^-?0\d/.test(num);

const generateValue = ({ autofillStart, currentValue, autofillPrefix, autofillSuffix }) => {
  // If start has leading zeros, pad the result numbers accordingly
  if (hasLeadingZero(autofillStart)) {
    const padLength = autofillStart.length;
    const autofillValue = String(currentValue).padStart(padLength, '0');
    const value = `${autofillPrefix}${autofillValue}${autofillSuffix}`;
    return value;
  } else {
    const autofillValue = String(currentValue);
    const value = `${autofillPrefix}${autofillValue}${autofillSuffix}`;
    return value;
  }
};

export const generateListByPattern = data => {
  const { autofillStart, autofillEnd, autofillSteps, autofillPrefix, autofillSuffix, isAutofillSettingsVisible, autofillSetting, loopsAmount, repeatsAmount } = data;
  // Convert the inputs to numbers
  const startNum = parseInt(autofillStart, 10);
  const endNum = parseInt(autofillEnd, 10);
  // Determine the step (either increment or decrement based on start and end)
  const step = startNum <= endNum ? autofillSteps : -autofillSteps;
  const result = [];

  if (isAutofillSettingsVisible) {
    switch (autofillSetting) {
      case AUTOFILL_SETTING_LOOP: {
        for (let j = 0; j < loopsAmount; j++) {
          for (let i = startNum; step > 0 ? i <= endNum : i >= endNum; i += step) {
            const value = generateValue({ autofillStart, currentValue: i, autofillPrefix, autofillSuffix });
            result.push(value);
          }
        }
        break;
      }
      case AUTOFILL_SETTING_REPEAT: {
        for (let i = startNum; step > 0 ? i <= endNum : i >= endNum; i += step) {
          for (let j = 0; j < repeatsAmount; j++) {
            const value = generateValue({ autofillStart, currentValue: i, autofillPrefix, autofillSuffix });
            result.push(value);
          }
        }
        break;
      }
      default: {
        break;
      }
    }
  } else {
    for (let i = startNum; step > 0 ? i <= endNum : i >= endNum; i += step) {
      const value = generateValue({ autofillStart, currentValue: i, autofillPrefix, autofillSuffix });
      result.push(value);
    }
  }

  return result;
};
